import React from 'react';
import {ItemWrapper, BadgeAlert} from "./main-panel-item.styles";

const MainPanelItem = ({label, icon: Icon, link, alert = false, clickHandler = () => {} }) => {
    return (
        <ItemWrapper className='d-flex align-items-center justify-content-between rtl' to={link} onClick={clickHandler}>
            {
                alert &&
                    <BadgeAlert />
            }
            <div className='d-flex align-items-center'>
                {Icon}
                <p className='sky-color me-3 mb-0'>{label}</p>
            </div>
            <i className='icon-arrow arrow' />
        </ItemWrapper>
    );
};

export default MainPanelItem;
